export default __webpack_public_path__ + "static/media/energisingchocolate@2x.3d1c9cc5.jpg";